import Vue from 'vue'
import ConfirmComponent from './Confirm.vue'
import wshop from '@/main'

const ConfirmConstructor = Vue.extend(ConfirmComponent)

let currentInstance

const install = (Vue) => {
  const showConfirm = function (options = {}) {
    // 销毁之前的实例
    if (currentInstance) {
      currentInstance.vm.$destroy()
      if (currentInstance.vm.$el && currentInstance.vm.$el.parentNode) {
        currentInstance.vm.$el.parentNode.removeChild(currentInstance.vm.$el)
      }
    }

    // 处理参数
    const propsData = {
      title: options.title || '',
      content: options.content || '',
      confirmText: options.confirmText || '',
      cancelText: options.cancelText || '',
      hideCancel: options.hideCancel || false,
      hideConfirm: options.hideConfirm || false,
      confirm: options.confirm || (() => {}),
      cancel: options.cancel || (() => {}),
      icon: options.icon || '',
      hideClose: options.hideClose || false,
      contentHtml: !!options.contentHtml,
    }

    // 获取主应用实例作为parent，确保能访问到i18n配置
    const parent = wshop || (this && this.$root ? this : undefined)

    // 创建新实例，传入parent以继承主应用的配置（包括i18n）
    currentInstance = new ConfirmConstructor({
      propsData,
      parent, // 关键：继承主应用的配置
    })

    // 挂载实例
    currentInstance.vm = currentInstance.$mount()
    document.body.appendChild(currentInstance.vm.$el)

    // 显示确认框
    currentInstance.vm.open(propsData)
    currentInstance.vm.visible = true

    return currentInstance.vm
  }

  // 注册到Vue原型
  Vue.prototype.$confirm = showConfirm
}

// 自动安装
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
}
